import PropTypes from "prop-types";
import { getReturnSteps, getStatusLabel } from "./refundFlow";

/*
 * The refund document holds one timestamp (`createdAt`) and the current
 * status — there is no per-event history to read. So the log lists the
 * stages the request has genuinely reached, newest first, and dates only
 * the event we hold a time for.
 */
const ReturnActivityLog = ({ status, createdAt, productName, imageCount }) => {
  const reached = getReturnSteps(status).filter((step) => !step.pending);

  const detail = {
    submitted: `Your return request${
      productName ? ` for ${productName}` : ""
    } was received${
      imageCount ? ` with ${imageCount} photo${imageCount === 1 ? "" : "s"}` : ""
    }.`,
    review: "Our returns team is checking the claim against the return policy.",
    decision: `Outcome recorded as ${getStatusLabel(status)}. A confirmation email has been sent.`,
  };

  const submitted = createdAt ? new Date(createdAt) : null;

  const entries = reached
    .map((step) => ({
      key: step.key,
      title: step.label,
      text: detail[step.key],
      time: step.key === "submitted" ? submitted : null,
    }))
    .reverse();

  return (
    <section className="c4rtn__card" aria-labelledby="c4rtn-log-heading">
      <h2 className="c4rtn__card-title" id="c4rtn-log-heading">
        Activity Log
      </h2>

      <ol className="c4rtn__log">
        {entries.map((entry, index) => (
          <li
            className={`c4rtn__log-item${
              index === 0 ? " c4rtn__log-item--latest" : ""
            }`}
            key={entry.key}
          >
            <span className="c4rtn__log-dot" aria-hidden="true" />
            <div className="c4rtn__log-body">
              {entry.time ? (
                <time
                  className="c4rtn__log-time"
                  dateTime={entry.time.toISOString()}
                >
                  {entry.time.toLocaleDateString(undefined, {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                  {" · "}
                  {entry.time.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </time>
              ) : null}
              <p className="c4rtn__log-title">{entry.title}</p>
              <p className="c4rtn__log-text">{entry.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

ReturnActivityLog.propTypes = {
  status: PropTypes.string,
  createdAt: PropTypes.string,
  productName: PropTypes.string,
  imageCount: PropTypes.number,
};

export default ReturnActivityLog;
